export default "__VITE_ASSET__DpAAiG9E__"